(()=>{
/* Scoped carousel only. No autoplay, network, storage, cart or submission. */
const init=(scope)=>{scope.querySelectorAll('.alo-campaign [data-carousel]').forEach(root=>{
  if(root.dataset.aloReady==='true')return;root.dataset.aloReady='true';
  const track=root.querySelector('.carousel-track'), slides=[...track.children];
  const prev=root.querySelector('[data-prev]'),next=root.querySelector('[data-next]');
  const dots=[...root.querySelectorAll('[data-dot]')], status=root.querySelector('[data-status]');
  let frame=0;
  const position=()=>Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/track.clientWidth)));
  function update(){const i=position();root.dataset.current=String(i);status.textContent=`${i+1} / ${slides.length}`;prev.disabled=i===0;next.disabled=i===slides.length-1;dots.forEach((d,n)=>{d.setAttribute('aria-current',n===i?'true':'false');});}
  function go(i){i=Math.max(0,Math.min(slides.length-1,i));track.scrollTo({left:i*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
  prev.addEventListener('click',()=>go(position()-1));next.addEventListener('click',()=>go(position()+1));
  dots.forEach((d,i)=>d.addEventListener('click',()=>go(i)));
  root.addEventListener('keydown',e=>{if(e.altKey||e.ctrlKey||e.metaKey)return;let to;
    if(e.key==='ArrowRight')to=position()+1;else if(e.key==='ArrowLeft')to=position()-1;else if(e.key==='Home')to=0;else if(e.key==='End')to=slides.length-1;else return;
    e.preventDefault();go(to);
  });
  track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(update);},{passive:true});
  new ResizeObserver(()=>{const i=Number(root.dataset.current||0);track.scrollTo({left:i*track.clientWidth,behavior:'instant'});update();}).observe(track);
  update();
});};
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});}else{init(document);}
document.addEventListener('shopify:section:load',e=>init(e.target));
})();
